import {
  type FC,
  type PropsWithChildren,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import { PackageContext } from '../../../modules/context/packageContext';
import { UserPropertiesContext } from '../../../modules/context/userPropertiesContext';
import { useLoading } from '../../../modules/hooks';
import type { PackagesResponse } from '../../../modules/interfaces';
import { useGetAllPackages } from '../../Dashboards/Packages/packageEnpoints';

export const PackageProvider: FC<PropsWithChildren> = ({ children }) => {
  const [packages, setPackages] = useState<PackagesResponse[]>([]);
  const { selectedProperty } = useContext(UserPropertiesContext)!;

  const [{ data, loading }, refetch] = useGetAllPackages(
    selectedProperty?.property.uuid || '',
  );
  const { setLoading } = useLoading()!;

  useEffect(() => {
    if (!data || loading) return;

    setPackages(data.result);
  }, [data, loading]);

  useEffect(() => {
    setLoading(loading);
  }, [loading, setLoading]);

  const packageContext = useMemo(() => {
    return { packages, refetch, loading };
  }, [packages, refetch, loading]);

  return (
    <PackageContext.Provider value={packageContext}>{children}</PackageContext.Provider>
  );
};
